<template>

<div class="row">
    
    <div class="col-12">
        <h1>Welcome to videa</h1>
    </div>

</div>

</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
